import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import * as JSZip from 'jszip';
import { BackgroundService } from 'src/app/core/services/background.service';
import { VehicleService } from 'src/app/core/services/vehicle.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {

  requestId: string;
  request: any;

  constructor(
    private backgroundService: BackgroundService,
    private route: ActivatedRoute,
    private vehicleService: VehicleService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.requestId = params.requestId;
      this.loadRequest();
    });
  }

  loadRequest() {
    this.backgroundService.getBackgroundRequest(this.requestId)
      .subscribe(
        res => {
          
          this.request = res;
        },
        err => {
          
        }
      );
  }

  getFileExtensionFromUrl(url) {
    return url.split(/\#|\?/)[0].split('.').pop().trim();
  }

  zipping = false;
  downloadFile(file, font?: boolean) {
    this.zipping = true;
    const data = [];
    data.push(file);

    if(font) {
      if (window.navigator.msSaveOrOpenBlob) {
        console.log('IE');
        window.navigator.msSaveBlob(file);
      }
      else {
        console.log('chrome');
        const a: any = document.createElement('a');
        document.body.appendChild(a);

        a.style.cssText = 'display: none';
        // const url = window.URL.createObjectURL(f);
        a.href = file;
        a.download = 'font';
        a.click();
        window.URL.revokeObjectURL(file);
      }

      this.zipping = false;
    } else {
      let files = data.map(file => file.path);

      this.vehicleService.downloadFiles(files).subscribe(responseList => {
        responseList.forEach((f: Blob, i: number) => {

          let fileExtension = this.getFileExtensionFromUrl(files[i]);
          let filename = data[i].filename;

          if (window.navigator.msSaveOrOpenBlob) {
            console.log('IE');
            window.navigator.msSaveBlob(f);
          }
          else {
            console.log('chrome');
            const a: any = document.createElement('a');
            document.body.appendChild(a);
  
            a.style.cssText = 'display: none';
            const url = window.URL.createObjectURL(new Blob([f]));
            a.href = url;
            a.download = `${filename}.${fileExtension}`;
            a.click();
            window.URL.revokeObjectURL(url);
          }
  
          this.zipping = false;
        });
      }, error => {
        
        this.zipping = false;
      });
    }

  }

}
